import React from 'react'
import { Database } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminSessions = () => {
  return (
    <GenericTable
      tableName="sessions"
      title="Sessions"
      icon={Database}
      iconColor="slate"
      searchFields={['session_id', 'user_id', 'user_type', 'email', 'ip_address', 'device_type']}
      hiddenFields={['session_id', 'created_at', 'updated_at']}
      primaryKey="session_id"
      defaultFields={['session_id', 'user_id', 'user_type', 'email', 'session_type', 'login_time', 'logout_time', 'ip_address', 'device_type', 'browser', 'os', 'location_city', 'location_state', 'location_country']}
      addFields={['user_id', 'user_type', 'email', 'ip_address', 'user_agent', 'device_type', 'browser', 'os']}
      editFields={[
        'session_type', 'user_type', 'ip_address', 'user_agent', 'device_type', 'browser', 'os',
        'location_city', 'location_state', 'location_country', 'session_duration_minutes', 'logout_reason'
        // Excluded: session_id, user_id, email, login_time, logout_time, created_at, updated_at
      ]}
    />
  )
}

export default AdminSessions
